import '../css/main.css';
import { initStoriesSlider } from './components/stories-slider';
import { initNewsSlider } from './components/news-slider';
import { initStepsLayout1Slider } from './components/steps-layout1-slider';
import { initStepsLayout2Slider } from './components/steps-layout2-slider';
import { initGallerySlider } from './components/gallery-slider';
import { initHighlightLayout3Slider } from './components/highlight-layout3-slider';
import { initHighlightLayout5Slider } from './components/highlight-layout5-slider';
import { initContentGridSlider } from './components/content-grid-slider';
import { initTilesColumnGridSlider } from './components/tiles-column-grid-slider';
import { initContentSlider } from './components/content-slider-slider';
import { initTreatmentsSlider } from './components/treatments-slider';
import { initTeamSlider } from './components/team-slider';
import { initAnchorNav } from './components/anchor';
import { initAccordion } from './components/accordion';
import { initSuccessRates } from './components/success-rates';
import { initSuccessRatesTab } from './components/success-rates-tab';
import { initAOS } from './components/aos';
import { initGlobal } from './components/global';
import { initNav } from './components/nav';
import { initMobileNavV3 } from './components/navigation-mobile-v3';
import { initPopupLinks } from './components/popup-link';
import { initPricing, initClinicSelect } from './components/pricing';
import { initPrice } from './components/price';
import { initFloatingContactBtn } from './components/floating-contact-btn';
import { initClinicLocatorBlocks } from './components/clinic-locator';
import { initMapBlocks } from './components/map-block';

document.addEventListener('DOMContentLoaded', () => {
    initStoriesSlider();
    initNewsSlider();
    initStepsLayout1Slider();
    initStepsLayout2Slider();
    initGallerySlider();
    initHighlightLayout3Slider();
    initHighlightLayout5Slider();
    initContentGridSlider();
    initTilesColumnGridSlider();
    initContentSlider();
    initTreatmentsSlider();
    initTeamSlider();
    initAnchorNav();
    initAccordion();
    initSuccessRates();
    initSuccessRatesTab();
    initAOS();
    initGlobal();
    initNav();
    initMobileNavV3();
    initPopupLinks();
    initPricing();
    initClinicSelect();
    initPrice();
    initFloatingContactBtn();
    initClinicLocatorBlocks();
    initMapBlocks();
    if (document.getElementById('oldTemplate')) {
        import('./components/gridcontent').then(({ initGridContent }) => {
            initGridContent();
        });
    }
});

import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';